import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { coreNavItems } from './navItems';

const NavLinks: React.FC = () => {
  return (
    <nav className="hidden lg:flex items-center gap-1">
      {coreNavItems.map((item) => (
        <RouterNavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            cn(
              'relative flex items-center gap-2 px-3 py-2 text-[13px] rounded-md transition-colors',
              isActive
                ? 'text-foreground font-medium after:absolute after:bottom-0 after:left-2 after:right-2 after:h-0.5 after:bg-primary after:rounded-full'
                : 'text-muted-foreground hover:text-foreground'
            )
          }
        >
          <item.icon className="h-4 w-4" />
          {item.label}
        </RouterNavLink>
      ))}
    </nav>
  );
};

export default NavLinks;
